import { render, staticRenderFns } from "./screenpic.vue?vue&type=template&id=8c808b18&scoped=true&"
import script from "./screenpic.vue?vue&type=script&lang=js&"
export * from "./screenpic.vue?vue&type=script&lang=js&"
import style0 from "./screenpic.vue?vue&type=style&index=0&id=8c808b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c808b18",
  null
  
)

export default component.exports